export const loadAudio = (filename) => new Promise((resolve) => {
        const audio = new Audio(filename);
        audio.addEventListener('canplaythrough', () => resolve(audio));
    }),
    createSounds = (sources) => {
        const library = {},
            promiseSources = Object
                .entries(sources)
                .map(([name, filenames]) => {
                    const promiseSamples = filenames.map(loadAudio),
                        assignSamples = (samples) => Object.assign(library, {[name]: samples});
                    return Promise
                        .all(promiseSamples)
                        .then(assignSamples)
                });
        return Promise
            .all(promiseSources)
            .then(() => library);
    },
    createAudio = (sources) => createSounds(sources).then(sounds => {
        const getSound = (name, s) => sounds[name][
            s === undefined
                ? Math.round(Math.random() * (sounds[name].length - 1))
                : s
        ];
        return {
            getSound,
            play: (name, s) => getSound(name, s).play()
        };
    });


// WEBPACK FOOTER //
// ./src/utils/sounds.js